import { render, staticRenderFns } from "./AssetAdditionsCreate.vue?vue&type=template&id=252e0cfd&"
import script from "./AssetAdditionsCreate.vue?vue&type=script&lang=ts&"
export * from "./AssetAdditionsCreate.vue?vue&type=script&lang=ts&"
import style0 from "./AssetAdditionsCreate.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ubuntu/agent/workspace/SPP/deployment/frontend-erp-spp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('252e0cfd')) {
      api.createRecord('252e0cfd', component.options)
    } else {
      api.reload('252e0cfd', component.options)
    }
    module.hot.accept("./AssetAdditionsCreate.vue?vue&type=template&id=252e0cfd&", function () {
      api.rerender('252e0cfd', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/assets/Additions/AssetAdditionsCreate.vue"
export default component.exports